import "../css/TeeStyles.css";
import { Accordion, accordionData } from "./smallComponents/listIconText";
import Dots from "../icons/assets/Dots.png";
import React from "react";
interface AccordionList {
  id: number | string;
  title: string;
  content: string;
}

const accordionObject: Array<AccordionList> = accordionData.map(
  (accordion, id) => ({
    id: id,
    title: accordion.title,
    content: accordion.content,
  })
);

const SectionFour: React.FC = () => {
  return (
    <div
      className="py-5 section px-4 px-md-5 mcm-dark-bg d-flex flex-wrap position-relative"
      data-aos="fade-up"
    >
      <div className="wid50 wid100Mobile d-flex ">
        <span className="white d-block align-self-center wid60 text-md-start text-center wid100Mobile fontSize34px lh-sm boldSeven">
          Any Questions? We’ve got you
        </span>
      </div>
      <div className="wid50 wid100Mobile accordions" data-aos="fade-down">
        <Accordion accordions={accordionObject} />
      </div>
    </div>
  );
};

export default SectionFour;
